import { useI18nextInstance } from "@squide/i18next";
import { useTranslation } from "react-i18next";
import { ErrorState } from "@packages/core-client/errors/ErrorState.tsx";
import { ErrorStateBackLink } from "@packages/core-client/errors/ErrorStateBackLink.tsx";
import { segmentsI18NextInstanceKey } from "../i18n/i18next.ts";

export interface SegmentNotFoundProps {
    segmentsListPath: string;
}

export function SegmentNotFound({ segmentsListPath }: SegmentNotFoundProps) {
    const i18nextInstance = useI18nextInstance(segmentsI18NextInstanceKey);
    const { t } = useTranslation("SegmentNotFound", { i18n: i18nextInstance });

    return <ErrorState kind="notFound" ownsPageTitle title={t("heading")} action={<ErrorStateBackLink href={segmentsListPath}>{t("backToSegments")}</ErrorStateBackLink>} />;
}
